/**
 * Sidebar navigation — mockup'taki yapıya birebir uyumlu.
 */
// Kullanıcı listesi artık üst seviye "Başa" modülünde — bu micro app içinde
// Kullanıcılar sayfası yok. Parametreler de Sistem sekmesinden kaldırılıp
// Oyunlaştırma altına taşındı; tüm oyunlaştırma ayarları tek grupta duruyor.
export const NAV_SECTIONS = [
  {
    label: 'Ana Menü',
    items: [
      { to: '/', label: 'Dashboard', icon: 'dashboard' },
    ],
  },
  {
    label: 'Oyunlaştırma',
    // Sıralama: bağımlılık zinciri (setup akışı). Parametreler temel taş
    // (baraj puan, formüller); Dönem onları referans verir; Görev Dönemi
    // referans verir; Sıralama hesaplama sonrası okuma ekranı.
    items: [
      { to: '/parameters', label: 'Parametreler', icon: 'settings' },
      { to: '/periods', label: 'Dönem Yönetimi', icon: 'calendar' },
      { to: '/tasks', label: 'Görev Yönetimi', icon: 'tasks' },
      { to: '/leaderboard', label: 'Sıralama', icon: 'trophy' },
      { to: '/badges', label: 'Rozetler', icon: 'badge' },
      { to: '/audit', label: 'Denetim Günlüğü', icon: 'audit' },
    ],
  },
];

// GAME_TYPES kaldırıldı. Dönem/görev hedeflemesi de kullanici_tipleri JSONB
// kolonu üzerinden yapılmıyor — artık CH ``segments`` tablosu tek kaynak
// (UI'da "Kullanıcı Tipi (Segment)" etiketi ile gösterilir). Kullanıcılar sayfası
// üst seviye "Başa" modülüne taşındığı için USER_TYPES sabiti de kaldırıldı.

export const METRIC_TYPES = [
  { value: 'COUNT', label: 'Adet (COUNT)', color: 'blue', hint: 'Kayıt sayısı (örn: 30 police)' },
  { value: 'SUM', label: 'Toplam (SUM)', color: 'green', hint: 'Toplam tutar (örn: 500K TL)' },
  { value: 'RATIO', label: 'Oran (RATIO)', color: 'orange', hint: 'Pay / Payda × 100 (örn: %70)' },
  { value: 'RANK', label: 'Sıra (RANK)', color: 'purple', hint: 'Sıralamaya göre puan' },
  { value: 'MANUAL', label: 'Manuel', color: 'neutral', hint: 'Admin tarafından manuel girilir (joker görev)' },
];

export const CANCELLATION_POLICIES = [
  {
    value: 'FULL_POINTS',
    label: 'Tam Puan Ver',
    description: 'Tüm oyunculara bu görevden max puan verilir',
  },
  {
    value: 'CANCEL_REVOKE',
    label: 'İptal & Geri Al',
    description: 'Görev iptal, kazanılan puanlar geri alınır',
  },
  {
    value: 'REPLACE_RECALC',
    label: 'Değiştir & Hesapla',
    description: 'Eski görev puanı geri, yeni görevle tekrar hesapla',
  },
];

export const PARAM_TYPES = [
  { value: 'STRING', label: 'STRING — Metin değer', color: 'blue' },
  { value: 'NUMBER', label: 'NUMBER — Sayısal değer', color: 'teal' },
  { value: 'LIST', label: 'LIST — Çoklu değer listesi', color: 'orange' },
  { value: 'BOOLEAN', label: 'BOOLEAN — Evet/Hayır', color: 'neutral' },
];

// Sistem Sabitleri kategorileri — refactor 2026-04 (backend migration 0006).
// 8 eski kategori (GENEL/BARAJ/ODUL/KADEME/FILTRE/FORMUL/BRANS/ESIK) 2 net
// kategoriye indirildi. Donem-ozel is kurallari Donemler ekraninda,
// gorev-ozel filtreler Gorevler ekraninda; burada yalnizca tum gorevlerde
// ortak kullanilan teknik sabitler tutulur.
export const PARAM_CATEGORIES = [
  {
    value: 'FILTRE',
    label: 'Filtre Listesi',
    color: 'purple',
    hint: 'Filtre degeri icin kullanilan listeler (aktif police durumlari, yeni_yenileme degerleri).',
  },
  {
    value: 'REFERANS',
    label: 'Referans Listesi',
    color: 'blue',
    hint: 'Referans ve kod listeleri (brans kodlari, HYO haric branslar).',
  },
];

